import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import useDataSourceContext from '../DataSource/useDataSourceContext';
import arrayFromNumber from '@afosto/utils/array/arrayFromNumber';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import PropTypes from 'prop-types';

const DataGridLoader = ({ size }) => {
  const { hasModule, pagination = {}, dataProperties = {} } = useDataSourceContext();
  const { itemsPerPage = 10 } = pagination;
  const { getActiveProperties } = dataProperties;
  const hasSelectionModule = hasModule('selection');
  const rowSelection = hasSelectionModule ? 1 : 0;
  const cellCount = getActiveProperties().length + rowSelection;

  return (
    <TableBody>
      {arrayFromNumber(itemsPerPage).map(rowIdx => (
        <TableRow key={rowIdx}>
          {arrayFromNumber(cellCount).map(cellIdx => (
            <TableCell key={cellIdx}>
              <SkeletonBody lines={cellIdx === 1 && size !== 'small' ? 2 : 1} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};

DataGridLoader.propTypes = {
  size: PropTypes.string,
};

DataGridLoader.defaultProps = {
  size: 'medium',
};

export default DataGridLoader;
